// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__27ilj","inputWrap":"Table_inputWrap__M4-Ra","col":"Table_col__iQTNR","bmiTooltip":"Table_bmiTooltip__3ixIS"};